import { useState } from "react";
import { motion } from "framer-motion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { GALLERY } from "../data/content";

const Grid = ({ images }) => (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
        {images.map((src, i) => (
            <motion.div
                key={src + i}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                data-testid={`gallery-img-${i}`}
                className={`relative overflow-hidden rounded-2xl group cursor-pointer ${i % 5 === 0 ? "md:row-span-2 aspect-square md:aspect-auto" : "aspect-[4/3]"}`}
            >
                <img src={src} loading="lazy" alt="Gallery item"
                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition" />
            </motion.div>
        ))}
    </div>
);

const Gallery = () => {
    const [tab, setTab] = useState("equipment");

    return (
        <section id="gallery" data-testid="gallery-section" className="relative py-20 sm:py-28">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-2xl mx-auto mb-12">
                    <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">Gallery</div>
                    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
                        A Glimpse of Our <span className="text-gradient-brand">Work</span>
                    </h2>
                </div>

                <Tabs value={tab} onValueChange={setTab} className="w-full">
                    <TabsList className="mx-auto flex w-fit bg-slate-100 dark:bg-slate-900 p-1.5 rounded-full mb-10">
                        <TabsTrigger data-testid="gallery-tab-equipment" value="equipment" className="rounded-full px-5 sm:px-6 data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:text-brand-700 dark:data-[state=active]:text-brand-300 data-[state=active]:shadow-sm">Equipment</TabsTrigger>
                        <TabsTrigger data-testid="gallery-tab-installation" value="installation" className="rounded-full px-5 sm:px-6 data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:text-brand-700 dark:data-[state=active]:text-brand-300 data-[state=active]:shadow-sm">Installation</TabsTrigger>
                        <TabsTrigger data-testid="gallery-tab-service" value="service" className="rounded-full px-5 sm:px-6 data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:text-brand-700 dark:data-[state=active]:text-brand-300 data-[state=active]:shadow-sm">Service</TabsTrigger>
                    </TabsList>
                    <TabsContent value="equipment"><Grid images={GALLERY.equipment} /></TabsContent>
                    <TabsContent value="installation"><Grid images={GALLERY.installation} /></TabsContent>
                    <TabsContent value="service"><Grid images={GALLERY.service} /></TabsContent>
                </Tabs>
            </div>
        </section>
    );
};

export default Gallery;
